import {
    PM_USERS_RESET_PASSWORD_OPEN_MODAL,
    PM_USERS_RESET_PASSWORD_CLOSE_MODAL,
    PM_USERS_RESET_PASSWORD_REQUEST,
    PM_USERS_RESET_PASSWORD_RESULT,
} from 'Redux/actionTypes';

export const resetPasswordPMUserOpenModal = (id) => ({
    type: PM_USERS_RESET_PASSWORD_OPEN_MODAL,
    payload: { id },
});

export const resetPasswordPMUserCloseModal = () => ({
    type: PM_USERS_RESET_PASSWORD_CLOSE_MODAL
});

export const resetPasswordPMUserRequest = (data) => ({
    type: PM_USERS_RESET_PASSWORD_REQUEST,
    payload: data,
});

export const resetPasswordPMUserResult = (result) => ({
    type: PM_USERS_RESET_PASSWORD_RESULT,
    payload: result,
});